<template>
  <div>
    <!-- 注册弹窗 -->
    <template  v-if="tanchu === 1">
      <div class="auibsu">
        <tancyg :tanchu="tanchu" @changeComponent1Data="component1DataChange"></tancyg>
      </div>
    </template>
    <!-- 登录框-->
    <template v-else>
      <el-dialog
      width="424px"
      class="newloginWrapper"
      :visible.sync="modelShow"
      :lock-scroll="false"
      @close="close"
      :modal-append-to-body="false"
      :close-on-click-modal="false"
      :close-on-press-escape="true">
      <denlyx ref="mychild" :data="isyouData" @immediatelyData="immediatelyData"></denlyx>
      </el-dialog>
    </template>

  </div>
</template>
<script>
import denlyx from "@/components/denlu/zhesdengl";
import tancyg from "@/components/user/registered";
var _poi;
export default {
  name: 'logon',
  components: {
    denlyx: denlyx,
    tancyg: tancyg,
  },
  props: {
    data: {
      type: Object,
      default () {
        return {};
      }
    }
  },
  data () {
    return {
      tanchu: 0,
      //是否显示本面板
      modelShow: false,
      // 获取登录后的ID
      userId: "",
      isyouData:{}, // 储存需要向登录传的值
    };
  },
  created () {
    _poi = this;
    this.tabchuyg(); // 默认进入初始化
  },
  methods: {
    tabchuyg() {
      if(this.data.tanchu && this.data.tanchu === 1){
        this.tanchu = this.data.tanchu
      }else{
        this.modelShow = this.data.modelShow;
        this.isyouData = {
          looke:this.data.islongoff
        }
        // 调用子组件生成二维码的方法
        this.$nextTick(() => {
          this.$refs.mychild.creatQrCode();
        });
      }
    },

    // 这里回去登录注册传过来的值，做判断点击的是忘记密码(0)，还是立即注册(1)
    immediatelyData(artlf, isd, usertype) {
      // 判断登录界面的操作
      if (artlf === "0") {
        this.tanchu = 1;
      } else if (artlf === "1") {
        this.modelShow = false;
      } else if (artlf === "2") {
        this.modelShow = false;
      }
    },

    component1DataChange(params) {
      let that = this;
      if (params === 0) {
        that.close();
        that.tanchu = 0;
      } else {
        // 调用子组件生成二维码的方法
        setTimeout(()=>{
          that.$refs.mychild.creatQrCode();
        },1000)

        that.tanchu = 0;
        that.modelShow = true;
      }
    },

    // 这个是数据清空 返回
    close () {
      this.$emit('close');
    },




  }
};
</script>






// WEBPACK FOOTER //
// src/views/classUtils/signin/logon.vue